// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3qGp6","title":"AfterFrontImage_title__1tKkM"};